import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-reporte-delitos-informaticos',
  templateUrl: './reporte-delitos-informaticos.component.html',
  styleUrls: ['./reporte-delitos-informaticos.component.scss'],
})
export class ReporteDelitosInformaticosComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      numero_denuncia: [
        values ? values.numero_denuncia : '',
        [Validators.required, Validators.pattern(/^[0-9]\d*$/)],
      ],
      fecha_denuncia: [
        values ? values.fecha_denuncia : '',
        [Validators.required],
      ],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
